import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  Select,
  Stack,
  TextField,
} from '@mui/material'
import * as React from 'react'
import {
  listFromCodes,
  listFromKV,
} from '../../../../Functions/ListItemGenerator'
import { useHealthContext } from '../../../../Contexts/Modules/HealthModule/HealthModule'

import { useUserContext } from '../../../../Contexts/UserConfig'
import { tsScreenCollection } from '../../../../Typescript/DB_Interface'
import CriteriaDetailsField from './CriteriaDetailsField'
import TestsField from './TestsField'
import { useCollectionSampleTypeOptions } from './CollectionSampleTypeOptions'
import { stackGap } from '../../../../Constants&Theme/Spacing'
import { validCollection } from './ValidCollection'
import { useAddCollection } from './useAddCollection'
import { LoadingButton } from '@mui/lab'
import { useLocation } from 'react-router-dom'

function CollectionDialog({
  open,
  setOpen,
  setCloneCollects,
  mode,
}: {
  open: (Partial<tsScreenCollection> & { index: number }) | undefined
  setOpen: any
  mode: 'edit' | 'add'
  setCloneCollects: any
}) {
  const { pathname } = useLocation()
  const clone = pathname.includes('/clone')
  const { loginConfig, loadingConfig } = useUserContext()
  const { screenFacilityQuery } = useHealthContext()
  //Line and Test label saved in DB as CSV (", ")
  const facilities = listFromKV(
    screenFacilityQuery.data ?? [],
    screenFacilityQuery.isLoading,
  )
  const sampleTypeOptions = useCollectionSampleTypeOptions()
  const { mutate: saveCollection, isLoading } = useAddCollection(open, setOpen)

  return (
    <Dialog open={!!open}>
      <DialogTitle>
        {mode === 'edit' ? 'Edit collection' : 'Add a new collection'}
      </DialogTitle>
      <DialogContent sx={{ minWidth: '500px' }}>
        <Stack
          sx={{ mt: 1 }}
          gap={stackGap.col}
          width={1}
        >
          <Stack
            direction={'row'}
            gap={stackGap.row}
            width={1}
          >
            <FormControl
              required
              fullWidth
            >
              <InputLabel>Sample Type</InputLabel>
              <Select
                label="Sample Type"
                name="SampleType"
                onChange={(e) =>
                  setOpen((c: any) => {
                    return {
                      ...c,
                      SampleType: e.target.value,
                    }
                  })
                }
                value={open?.SampleType ?? ''}
              >
                {sampleTypeOptions}
              </Select>
            </FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  name="Rebill"
                  checked={open?.Rebill === 'Y'}
                  onChange={(e) => {
                    setOpen((c: any) => {
                      return {
                        ...c,
                        Rebill: e.target.checked ? 'Y' : 'N',
                      }
                    })
                  }}
                />
              }
              label="Rebill"
              labelPlacement="start"
            />
          </Stack>
          <FormControl
            required
            fullWidth
          >
            <InputLabel>Destination Lab</InputLabel>
            <Select
              label="Destination Lab"
              name="DestinationFacilityID"
              value={open?.DestinationFacilityID ?? ''}
              onChange={(e) => {
                setOpen((c: any) => {
                  let newC = {
                    ...c,
                    DestinationFacilityID: e.target.value as any,
                  }
                  if (e.target.value === 67) {
                    newC = {
                      ...newC,
                      Tests: '',
                    }
                  }
                  return newC
                })
              }}
            >
              {facilities}
            </Select>
          </FormControl>
          <FormControl
            required
            fullWidth
          >
            <InputLabel>Sample represents</InputLabel>
            <Select
              label="Sample represents"
              name="Criteria"
              value={open?.Criteria ?? ''}
              onChange={(e) => {
                setOpen((c: any) => {
                  return {
                    ...c,
                    Criteria: e.target.value,
                    CriteriaDetails: '',
                  }
                })
              }}
            >
              {listFromCodes(loginConfig, 'ScreenCriteriaID', loadingConfig)}
            </Select>
          </FormControl>
          <CriteriaDetailsField
            addCollection={open}
            setAddCollection={setOpen}
          />
          <TestsField
            addCollection={open}
            setAddCollection={setOpen}
          />
          <Stack
            direction={'row'}
            gap={stackGap.row}
            width={1}
          >
            <FormControl
              required
              sx={{ flex: 1 }}
            >
              <InputLabel>Sample Source</InputLabel>
              <Select
                label="Sample Source"
                name="SampleSource"
                onChange={(e) =>
                  setOpen((c: any) => {
                    return {
                      ...c,
                      SampleSource: e.target.value,
                      SampleSourceOther: '',
                    }
                  })
                }
                value={open?.SampleSource || ''}
              >
                {listFromCodes(loginConfig, 'SampleSourceID', loadingConfig)}
              </Select>
            </FormControl>
            {open?.SampleSource === '9' && (
              <TextField
                sx={{ flex: 2 }}
                label="Other Sample Source"
                onChange={(e) =>
                  setOpen((c: any) => {
                    return {
                      ...c,
                      SampleSourceOther: e.target.value,
                    }
                  })
                }
                value={open?.SampleSourceOther ?? ''}
              />
            )}
          </Stack>
          <TextField
            label="Collection Instructions"
            value={open?.CollectionInstructions ?? ''}
            fullWidth
            onChange={(e) =>
              setOpen((c: any) => {
                return {
                  ...c,
                  CollectionInstructions: e.target.value,
                }
              })
            }
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(undefined)}
          color="error"
        >
          Cancel
        </Button>
        <LoadingButton
          loading={isLoading}
          onClick={() => {
            if (clone) {
              setCloneCollects((c: any) => {
                const newC = c
                newC.splice(open!.index, open!.index === c.length ? 0 : 1, open)
                return [...newC]
              })
              setOpen(undefined)
            } else {
              saveCollection()
            }
          }}
          disabled={!validCollection(open)}
          color="success"
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default CollectionDialog
